import React from "react";
import { Sidebar } from "./components/Sidebar";
import { OrganizationProvider } from "./contexts/organization-context";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <OrganizationProvider>
      <div className="grid min-h-screen w-full md:grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]">
        <Sidebar />
        <main className="flex-1">{children}</main>
      </div>
    </OrganizationProvider>
  );
} 